import React from "react";
import FormContentWrapper from "Components/FormContentWrapper";
import { useFormData } from "Contexts/FormDataContext";
import { useSession } from "Contexts/SessionContext";
import usePageContextUpdate from "Hooks/usePageContextUpdate";
import MarketingPainPointsFormContent from "Components/MarketingPainPoints/MarketingPainPointsFormContent";
import MarketingPainPointsInfoContent from "Components/MarketingPainPoints/MarketingPainPointsInfoContent";
import { getPageNumber } from "Data";

const MarketingPainPointsPage = () => {
  const { currentPageData, setSubmitted } = usePageContextUpdate();

  const {
    updateMarketingPainPoints,
    currentFormData: { marketingPainPoints },
  } = useFormData();

  const { updateSession, sessionData } = useSession();

  const handleSubmit = async (selectedPainPoints) => {
    updateMarketingPainPoints(selectedPainPoints);

    await updateSession({
      current_page: getPageNumber("privacy-send"),
      responses: {
        ...sessionData?.responses,
        q9_pain_points: {
          painPoints: selectedPainPoints,
        },
      },
    });

    setSubmitted(true);
  };

  return (
    <FormContentWrapper
      infoContent={
        <MarketingPainPointsInfoContent heading={currentPageData.pageTitle} />
      }
      formFieldContent={
        <MarketingPainPointsFormContent
          submitCB={handleSubmit}
          defaultPainPoints={marketingPainPoints}
        />
      }
    />
  );
};

export default MarketingPainPointsPage;
